namespace Areas {
    "use strict";

    const exportButtonName = "exportButton";

    export function addExport(e: any) {
        const grid: DevExpress.ui.dxDataGrid = e.component;
        
        addButtonToToolbar(e.toolbarOptions, {
            elementAttr: { id: exportButtonName, "class": "dx-datagrid-export-button" },
            text: "Export",
            hint: "Export all rows to Excel",
            type: "normal",
            icon: "export-excel-button",
            onClick: exportData(grid)
        }, "after");

        grid.on("exporting", onExporting);
        
    } 
  
    function exportData(grid: DevExpress.ui.dxDataGrid) {
        return (e: any) => {
            grid.exportToExcel(false);
        }
    }

    function onExporting (e: any) {
        const grid: DevExpress.ui.dxDataGrid = e.component;

        e.fileName = grid.option("gridName");
    }    
    
}